/* eslint-disable max-len */
export const routePaths = {
    home: '/home',

    profile: '/profile',
    profileThemeSettings: '/profile/theme-settings',
    profileAccessibilitySettings: '/profile/accessibility-settings',
    profilePrivacyAndSecuritySettings: '/profile/privacy-and-security-settings',
    profilePrivacyAndSecuritySettingsChangePassword: '/profile/privacy-and-security-settings/change-password',
    profileNotificationSettings: '/profile/notification-settings',
    profileNotificationSettingsAddUserGroup: '/profile/notification-settings/add-user-group',
    profileNotificationSettingsEditProfile: '/profile/notification-settings/edit-profile/:id/:name',
    profilePersonalAccessToken: '/profile/personal-access-token',
    profilePersonalAccessTokenAdd: '/profile/personal-access-token/add',
    profilePersonalAccessTokenCreate: '/profile/personal-access-token/create',
    profilePersonalAccessTokenAddScopes: '/profile/personal-access-token/create/scopes',
    profilePersonalAccessTokenView: '/profile/personal-access-token/view',

    notifications: '/notifications',

    resourceCenter: '/resource-center',
    resourceCenterCMSUpgradeToEnterprise: '/resource-center/upgrade',

    admin: '/admin',

    adminIdentities: '/admin/identities',
    adminIdentitiesUsers: '/admin/identities/users',
    adminIdentitiesUsersAdd: '/admin/identities/users/add',
    // TODO: Refactor this route to pass in :userId
    adminIdentitiesUsersEdit: '/admin/identities/users/edit',
    adminIdentitiesUsersBulkAdd: '/admin/identities/users/bulk-add',
    // TODO: Refactor all licensing to pass in :userId
    adminIdentitiesUsersLicenseAdd: '/admin/identities/users/license/add',
    adminIdentitiesUsersLicenseEdit: '/admin/identities/users/license/edit',
    adminIdentitiesUsersLicenseInheritance: '/admin/identities/users/license/inheritance',
    adminIdentitiesGroups: '/admin/identities/groups',
    adminIdentitiesGroupsAdd: '/admin/identities/groups/add',
    adminIdentitiesGroupsEdit: '/admin/identities/groups/:id',
    adminIdentitiesGroupsLicenseAdd: '/admin/identities/groups/license/add',
    adminIdentitiesGroupsLicenseEdit: '/admin/identities/groups/license/edit',
    adminIdentitiesRobots: '/admin/identities/robots',
    adminIdentitiesRobotsAdd: '/admin/identities/robots/add',
    // TODO: Refactor this route to pass in :robotId
    adminIdentitiesRobotsEdit: '/admin/identities/robots/edit',
    // Shared profile routes
    adminIdentitiesProfileGroupMemberships: '/admin/identities/:entity/:id/group-memberships',
    adminIdentitiesProfileGroupMembershipsAdd: '/admin/identities/:entity/:id/group-memberships/add',
    adminIdentitiesProfileMembers: '/admin/identities/:entity/:id/members',
    adminIdentitiesProfileMembersAdd: '/admin/identities/:entity/:id/members/add',
    adminIdentitiesProfileAccess: '/admin/identities/:entity/:id/access',
    adminIdentitiesProfileInfo: '/admin/identities/:entity/:id/info',
    adminIdentitiesProfileLicenses: '/admin/identities/:entity/:id/licenses',
    adminIdentitiesProfileLicensesEdit: '/admin/identities/:entity/:id/licenses/edit',
    adminIdentitiesProfileLicensesInheritance: '/admin/identities/:entity/:id/licenses/inheritance',

    adminManageAccess: '/admin/manage-access',

    adminAiTrustLayer: '/admin/ai-trust-layer',
    adminAiTrustLayerUsage: '/admin/ai-trust-layer/usage',
    adminAiTrustLayerAudit: '/admin/ai-trust-layer/audit',
    adminAiTrustLayerGovernance: '/admin/ai-trust-layer/governance',
    adminAiTrustLayerA4E: '/admin/ai-trust-layer/a4e',
    adminAiTrustLayerContextGrounding: '/admin/ai-trust-layer/context-grounding',
    adminAiTrustLayerLlmConfigurations: '/admin/ai-trust-layer/llm-configurations',
    adminAiTrustLayerLlmConfigurationsAdd: '/admin/ai-trust-layer/llm-configurations/:tenantId/:folderId/add',
    adminAiTrustLayerLlmConfigurationsView: '/admin/ai-trust-layer/llm-configurations/:tenantId/:folderId/view/:id',
    adminAiTrustLayerLlmConfigurationsEdit: '/admin/ai-trust-layer/llm-configurations/:tenantId/:folderId/edit/:id',
    adminAiTrustLayerOtelConfigurations: '/admin/ai-trust-layer/otel-configurations',

    adminGovernance: '/admin/governance',
    adminGovernanceCreate: '/admin/governance/create',

    // TODO: Refactor edit routes to take an id
    adminLicenses: '/admin/licenses',
    adminLicensesUpgrade: '/admin/licenses/upgrade',
    adminLicensesUsers: '/admin/licenses/users',
    adminLicensesUsersAdd: '/admin/licenses/users/add',
    adminLicensesUsersEdit: '/admin/licenses/users/edit',
    adminLicensesUsersInherit: '/admin/licenses/users/inherit',
    adminLicensesGroups: '/admin/licenses/groups',
    adminLicensesGroupsAdd: '/admin/licenses/groups/add',
    adminLicensesGroupsEdit: '/admin/licenses/groups/edit',
    adminLicensesTenantEdit: '/admin/licenses/tenant/:type/:tenantId',
    // TODO: Routes for tabs in the licensing page. Currently not supported
    adminLicensesRobots: '/admin/licenses/robots',
    adminLicensesConsumables: '/admin/licenses/consumables',
    adminLicensesBuyProPresets: '/admin/licenses/buy-pro-presets',
    adminLicensesPending: '/admin/licenses/pending',
    adminLicensesOffline: '/admin/licenses/offline',
    adminLicensesOnline: '/admin/licenses/online',
    adminLicensesSuccess: '/admin/licenses/success',
    adminLicensesOfflineDeactivate: '/admin/licenses/offline/deactivate',

    adminSecurity: '/admin/security',
    adminSecurityAuthentication: '/admin/security/authentication',
    adminSecurityAuthenticationConfigure: '/admin/security/authentication/configure',
    adminSecurityAuthenticationConfigureMicrosoftEntraId: '/admin/security/authentication/configure/microsoft-entra-id',
    adminSecurityAuthenticationConfigureSAML: '/admin/security/authentication/configure/saml',
    adminSecurityAuthenticationConfigureAAD: '/admin/security/authentication/configure/aad',
    adminSecurityAuthenticationConfigureAD: '/admin/security/authentication/configure/ad',
    adminSecurityAuthenticationConfigureSAMLProvisioningRules: '/admin/security/authentication/configure/saml/provisioning-rules',
    adminSecurityAuthenticationConfigureSAMLProvisioningRulesAdd: '/admin/security/authentication/configure/saml/provisioning-rules/add',
    adminSecurityAuthenticationConfigureSAMLProvisioningRulesEdit: '/admin/security/authentication/configure/saml/provisioning-rules/edit/:id',
    adminSecurityAuthenticationAttributeMapping: '/admin/security/authentication/attribute-mapping/:type',
    adminSecurityAuthenticationPasswordPolicy: '/admin/security/authentication/password-policy',
    adminSecurityIpRestriction: '/admin/security/ip-restriction',
    adminSecurityIpRestrictionAdd: '/admin/security/ip-restriction/add',
    adminSecurityIpRestrictionEdit: '/admin/security/ip-restriction/edit/:id',
    adminSecurityIpRestrictionBulkAdd: '/admin/security/ip-restriction/bulk-add',
    adminSecuritySessionPolicy: '/admin/security/session-policy',
    adminSecurityEncryption: '/admin/security/encryption',
    adminSecurityEncryptionAdd: '/admin/security/encryption/add',
    adminSecurityEncryptionEdit: '/admin/security/encryption/edit',
    adminSecurityAccessRestriction: '/admin/security/access-restriction',
    adminSecurityAccessRestrictionAdd: '/admin/security/access-restriction/add',

    adminAudit: '/admin/audit',
    adminAuditDialog: '/admin/audit/dialog',

    adminExternalApps: '/admin/external-apps',
    adminExternalAppsOauth: '/admin/external-apps/oauth',
    adminExternalAppsOauthAdd: '/admin/external-apps/oauth/add',
    adminExternalAppsOauthAddScopes: '/admin/external-apps/oauth/add/scopes',
    adminExternalAppsOuathAddScopesName: '/admin/external-apps/oauth/add/scopes/:name',
    adminExternalAppsOauthEdit: '/admin/external-apps/oauth/edit/:id',
    adminExternalAppsOuathEditScopes: '/admin/external-apps/oauth/edit/:id/scopes',
    adminExternalAppsOauthEditScopesName: '/admin/external-apps/oauth/edit/:id/scopes/:name',
    adminExternalAppsPat: '/admin/external-apps/pat',
    adminExternalAppsPatSettings: '/admin/external-apps/pat/settings',
    adminExternalAppsPatView: '/admin/external-apps/pat/view',
    adminExternalAppsRegistrations: '/admin/external-apps/registrations',
    adminExternalAppsRegistrationsDetails: '/admin/external-apps/registrations/details/:publisherId/:id/:type',

    adminEmailSettings: '/admin/email-settings',

    adminSettings: '/admin/settings',
    adminSettingsGeneral: '/admin/settings/general',
    adminSettingsGeneralWarning: '/admin/settings/general/warning',
    adminSettingsAdvanced: '/admin/settings/advanced',
    adminSettingsLoginCustomization: '/admin/settings/login-customization',
    adminSettingsAdvancedMigration: '/admin/settings/advanced/migration',
    adminSettingsAdvancedMigrationEdit: '/admin/settings/advanced/migration/edit',

    adminUserConsent: '/admin/user-consent',
    adminUserConsentCreate: '/admin/user-consent/create',
    adminUserConsentEdit: '/admin/user-consent/edit/:id',

    adminTenant: '/admin/tenant',
    adminTenantCreate: '/admin/tenant/create',
    adminTenantHome: '/admin/tenant/:tenantId',

    adminTenantServices: '/admin/tenant/:tenantId/services',
    adminTenantServicesAdd: '/admin/tenant/:tenantId/services/add',
    adminTenantServicesConfigure: '/admin/tenant/:tenantId/services/:type',
    adminTenantServicesConfigureService: '/admin/tenant/:tenantId/services/:type/:serviceType',
    adminTenantServicesUsage: '/admin/tenant/:tenantId/services/usage',
    adminTenantServicesLogExport: '/admin/tenant/:tenantId/services/log-export',

    adminTenantManageAccess: '/admin/tenant/:tenantId/manage-access',
    adminTenantManageAccessCheckAccess: '/admin/tenant/:tenantId/manage-access/check-access',

    adminTenantLicenses: '/admin/tenant/:tenantId/licenses',
    adminTenantLicensesEditAllocation: '/admin/tenant/:tenantId/licenses/:type',

    adminTenantTags: '/admin/tenant/:tenantId/tags',
    adminTenantTagsLabels: '/admin/tenant/:tenantId/tags/labels',
    adminTenantTagsLabelsAdd: '/admin/tenant/:tenantId/tags/labels/add',
    adminTenantTagsLabelsEdit: '/admin/tenant/:tenantId/tags/labels/edit/:id',
    adminTenantTagsProperties: '/admin/tenant/:tenantId/tags/properties',
    adminTenantTagsPropertiesAdd: '/admin/tenant/:tenantId/tags/properties/add',
    adminTenantTagsPropertiesAddValues: '/admin/tenant/:tenantId/tags/properties/add/values',
    adminTenantTagsPropertiesEdit: '/admin/tenant/:tenantId/tags/properties/edit/:editType/:id',
    adminTenantTagsPropertiesEditValues: '/admin/tenant/:tenantId/tags/properties/edit/:editType/:id/values',

    adminTenantGateway: '/admin/tenant/:tenantId/gateway',
    adminTenantGatewayAddEdit: '/admin/tenant/:tenantId/gateway/:type',
    adminTenantGatewayAdd: '/admin/tenant/:tenantId/gateway/add',
    adminTenantGatewayEdit: '/admin/tenant/:tenantId/gateway/edit',
    adminTenantGatewayConnections: '/admin/tenant/:tenantId/gateway/connections/:vpnGatewayKey',
    adminTenantGatewayConnectionsAddEdit: '/admin/tenant/:tenantId/gateway/connections/:vpnGatewayKey/:type',
    adminTenantGatewayConnectionsAdd: '/admin/tenant/:tenantId/gateway/connections/:vpnGatewayKey/add',
    adminTenantGatewayConnectionsEdit: '/admin/tenant/:tenantId/gateway/connections/:vpnGatewayKey/edit',

    adminTenantAudit: '/admin/tenant/:tenantId/audit',

    adminTenantSettings: '/admin/tenant/:tenantId/settings',
    adminTenantSettingsMigration: '/admin/tenant/:tenantId/settings/migration',
    adminTenantSettingsMigrationEdit: '/admin/tenant/:tenantId/settings/migration/edit',

    adminHostOrganizationsAdd: '/admin/organizations/add',

    adminHostOrganizationHome: '/admin/organization/:organizationId',
    adminHostOrganizationLicense: '/admin/organization/:organizationId/license',
    adminHostOrganizationSettings: '/admin/organization/:organizationId/settings',

    adminHostLicense: '/admin/license',
    adminHostLicenseActivateOffline: '/admin/license/activate/offline',
    adminHostLicenseActivateOnline: '/admin/license/activate/online',
    adminHostLicenseDeactivateOffline: '/admin/license/deactivate/offline',

    adminHostIdentities: '/admin/identities',
    adminHostIdentitiesUsers: '/admin/identities/users',
    adminHostIdentitiesUsersAdd: '/admin/identities/users/add',
    // TODO: Refactor this route to take an id
    adminHostIdentitiesUsersEdit: '/admin/identities/users/edit',

    adminHostSecurity: '/admin/security',
    adminHostSecurityAuthentication: '/admin/security/authentication',
    adminHostSecurityAuthenticationPasswordPolicy: '/admin/security/authentication/password-policy',
    adminHostSecurityAuthenticationConfigureAD: '/admin/security/authentication/configure/ad',
    adminHostSecurityAuthenticationConfigureAAD: '/admin/security/authentication/configure/aad',
    adminHostSecurityAuthenticationConfigureGoogle: '/admin/security/authentication/configure/google',
    adminHostSecurityAuthenticationConfigureSaml: '/admin/security/authentication/configure/saml',
    adminHostSecurityAuthenticationConfigureADDirectory: '/admin/security/authentication/configure/ad-directory',
    adminHostSecuritySessionPolicy: '/admin/security/session-policy',

    adminHostMailSettings: '/admin/mail-settings',

    adminHostSettings: '/admin/settings',
    adminHostSettingsLoginCustomization: '/admin/settings/login-customization',

    adminHostAudit: '/admin/audit',
    adminHostAuditDialog: '/admin/audit/dialog',
    adminHostAuditLogs: '/admin/audit/logs',
    adminHostASPortal: '/admin/cluster-health',
} as const;

// export type RoutePath = typeof routePaths[keyof typeof routePaths];
